/* eslint-disable react-hooks/exhaustive-deps */
import "./admin-table.css";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import { BsEye, BsTrash3Fill } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteProfile,
  getUsersProfile,
} from "../../redux/apiCalls/profileApiCalls";
import { useEffect } from "react";

const UsersTable = () => {
  const dispatch = useDispatch();
  const profiles = useSelector((state) => state.profile.profiles);
  const { isProfileDeleted } = useSelector((state) => state.profile);

  useEffect(() => {
    dispatch(getUsersProfile());
  }, [isProfileDeleted]);

  // Delete User Handler
  const deleteUserHandler = (userId) => {
    swal({
      title: "هل تريد الحذف فعلا ؟",
      text: "لن تستطيع بيانات هذا المستخدم ثانية",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((isPk) => {
      if (isPk) {
        dispatch(deleteProfile(userId));
      }
    });
  };

  return (
    <div className="table-container">
      <div className="table-wrapper">
        <h1 className="table-title">المستخدمون</h1>
        <table className="table">
          <thead>
            <tr>
              <th>م</th>
              <th>المستخدم</th>
              <th>الاميل</th>
              <th>عمليات</th>
            </tr>
          </thead>
          <tbody>
            {profiles?.map((item, index) => (
              <tr key={item?._id}>
                <td>{index + 1}</td>
                <td>
                  <div className="table-image">
                    <img
                      src={item?.profilePhoto?.url}
                      alt=""
                      className="table-user-image"
                    />
                    <span className="table-username">{item?.username}</span>
                  </div>
                </td>
                <td>
                  <b className="user-email">{item?.email}</b>
                </td>
                <td>
                  <div className="table-button-group">
                    <button>
                      <Link
                        className="table-button-group"
                        to={`/profile/${item?._id}`}
                      >
                        <BsEye />
                      </Link>
                    </button>
                    <button onClick={() => deleteUserHandler(item?._id)}>
                      <BsTrash3Fill />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UsersTable;
